import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class CustomTitleStrategy extends TitleStrategy {
    constructor(
        private readonly title: Title,
        private readonly translate: TranslateService
    ) {
        super();
    }

    override updateTitle(snapshot: RouterStateSnapshot): void {
        // from the root route until we find one that has 'title'
        let currentRoute = snapshot.root;
        while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
        }

        const titleKey = currentRoute.title;

        if (titleKey && typeof titleKey === 'string') {
            const translatedTitle = this.translate.instant(titleKey);
            this.title.setTitle(translatedTitle);
        }
    }
}
